import { render, staticRenderFns } from "./myShare.vue?vue&type=template&id=04978f8b"
import script from "./myShare.vue?vue&type=script&lang=js"
export * from "./myShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports